import React, { useEffect, useState } from "react";
import { ArticleTeaser } from "../ArticleTeaser/ArticleTeaser";
import { ArticleListViewModel } from "./ArticleListViewModel.csharp";
import { ArticleListLayout } from "./ArticleListLayout.csharp";

const ArticleNumberBreakpoint = 16;

export const ArticleList: React.FC<ArticleListViewModel> = ({
  articles,
  layout,
}) => {
  const [showAll, setShowAll] = useState(articles.length < ArticleNumberBreakpoint);
  
  const articlesSlice = showAll
    ? articles
    : articles.slice(0, ArticleNumberBreakpoint);

  return (
    <div className="mb-4">
      <div className="row row-tight">
        <div className="edge-to-edge-sm col-sm-16 col-md-18 col-xl-14">
          {layout !== ArticleListLayout.Vertical && (
            <div className="row row-tight">
              {articlesSlice.map((article, index) => (
                <ArticleTeaser
                  key={index}
                  {...article}
                  verticalLayout={false}
                />
              ))}
            </div>
          )}
          {layout == ArticleListLayout.Vertical && (
            <div className="row row-tight">
              {articlesSlice.map((article, index) => (
                <ArticleTeaser
                  key={index}
                  {...article}
                  verticalLayout={layout == ArticleListLayout.Vertical}
                />
              ))}
            </div>
          )}
        </div>
      </div>

      {!showAll && (
        <button
          onClick={() => setShowAll(true)}
          className="btn-link link-list--simple__load-more mt-1"
        >
          Vis alle artikler
        </button>
      )}
    </div>
  );
};
